
import {createSlice} from "@reduxjs/toolkit";

export const contractSlice = createSlice({
    name: 'contractSlc',
    initialState: {value: {id: 0, mcode: null, name: null, description: null,
            status: null, hierarchy: null,
            mockHealthCheck: null, mockException: null, mockImpeded: null, mockNeeded: null,
            mockCompleted: null, mockTotalCDP: null, mockTotalFilters: null,
            createdOn: null,createdBy:null,lastModifiedOn:null,lastModifiedBy:null,
            contractGridAPI: "CBA",
            residualsTabsVisible: false
            ,contractGridVisible: false
            ,contractDrawerMode: null
            ,contractDrilldownVisible: false
            ,contractSearchVisible: false
            ,contractConfigVisible: false
            ,contractView: null
            ,participationsTabsVisible: false
            ,royaltiesTabsVisible: false
            ,cGridRefresh: false
            ,module: null
            ,workTabsVisible: false,
            cloneId: 0,
            partitionKey: null,

            participationsTabsIndex: 0,
            residualsTabsIndex: 0,
            royaltiesTabsIndex: 0,

            csCount: null,
            csfCount: null,
            cdpCount: null,
            cdpvCount: null,
            cdpvfCount: null,
            vocabCount: null,
            marketCount: null,

            contractIdGeneratedFromAbstract: null,

            page: 0,
            pageSize: 50,
            rowsPerPageOptions: [50, 100, 200],
            sortModel: null,
            filterModel: null,


    }},
    reducers:
{
    changeContract: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const { changeContract } = contractSlice.actions;

export default  contractSlice.reducer ;
